// extracted by mini-css-extract-plugin
export default {"root":"td-label_root__9shzi","label":"td-label_label__r3Wgv","placeHolderShimmer":"td-label_placeHolderShimmer__9r7wq"};